import React from 'react'
import PropTypes from 'prop-types'
import SpinnerLoader from 'shared/components/Loaders/SpinnerLoader'
import { Form } from 'react-bootstrap'
import CustomSelect from 'shared/components/CustomSelect'
import LookupTabsLegend from 'Lookup/LookupTabsLegend'

import classnames from 'classnames'

import './style.scss'

export const ALL_BUILDINGS_LABEL = 'All buildings on lot'
export const ALL_BUILDINGS_VALUE = '__all_buildings__'

class BuildingSelect extends React.Component {
  constructor(props) {
    super(props)

    this.getBuildingOptions = this.getBuildingOptions.bind(this)
    this.getOptionClassName = this.getOptionClassName.bind(this)
  }

  getOptionClassName({ data, isFocused, isSelected }) {
    return classnames(
      data.value === ALL_BUILDINGS_VALUE
        ? 'building-select__option--lot'
        : 'building-select__option--building',
      {
        'building-select__option--focused': isFocused,
        'building-select__option--selected': isSelected,
      }
    )
  }

  getBuildingOptions() {
    const currentBin = this.props.bin ? String(this.props.bin) : null

    const buildings = this.props.propertyResult.buildings
      .filter(building => {
        const address = `${building.house_number} ${building.stname}`
        // Keep the active building even when it shares the lot address (otherwise
        // react-select can't match the current value when the menu opens).
        if (currentBin && String(building.bin) === currentBin) return true
        return address !== this.props.propertyResult.address
      })
      .map(building => ({
        value: String(building.bin),
        label: `${building.house_number} ${building.stname}`,
      }))

    return [{ value: ALL_BUILDINGS_VALUE, label: ALL_BUILDINGS_LABEL }, ...buildings]
  }

  getSelectedValue(options) {
    if (this.props.bin) {
      const match = options.find(option => option.value === String(this.props.bin))
      if (match) return match
    }

    return options.find(option => option.value === ALL_BUILDINGS_VALUE)
  }

  render() {
    if (!Object.keys(this.props.propertyResult).length) return null
    if (this.props.propertyResult.buildings.length <= 1) return null
    const options = this.getBuildingOptions()
    return !this.props.loading ? (
      <Form className="building-select">
        <div className="building-select__wrapper">
          <div className="building-select__group">
            <label className="building-select__label" htmlFor="building-select-input">
              Building:
            </label>
            <div className="building-select__select-group">
              <CustomSelect
                inputId="building-select-input"
                className={classnames('building-select__select', { valued: this.props.bin })}
                classNames={{ option: this.getOptionClassName }}
                size="sm"
                onChange={e => {
                  const bin =
                    e?.value && e.value !== ALL_BUILDINGS_VALUE ? e.value : undefined
                  this.props.changeLookup(this.props.bbl, bin, true)
                }}
                options={options}
                value={this.getSelectedValue(options)}
              />
            </div>
            <div className="building-select__legend-row">
              <LookupTabsLegend />
            </div>
          </div>
        </div>
      </Form>
    ) : (
      <div className="my-4">
        <SpinnerLoader size="" />
      </div>
    )
  }
}

BuildingSelect.defaultProps = {
  buildings: [],
}

BuildingSelect.propTypes = {
  changeLookup: PropTypes.func,
  bbl: PropTypes.string,
  bin: PropTypes.string,
  dispatch: PropTypes.func,
  propertyResult: PropTypes.object,
}

export default BuildingSelect
